import { MenuState } from '@features/main/interfaces/main.interfaces';
import useLogoStyles from './Logo.styles';
import IconImage from './Icon.svg';
import LogoImage from './Logo.svg';

interface Props {
	menuState: MenuState;
}

const Logo: React.FC<Props> = ({ menuState }) => {
	const classes = useLogoStyles();

	return (
		<div className={classes.root}>
			<img alt="Icono de Coordinadora" className={classes.icon} src={IconImage} />
			{menuState === 'big' && (
				<div id="sidebar-menu-logo-text">
					<img alt="Logo Coordinadora Blanco" height={13} src={LogoImage} width={138} />
					<p className={classes.pageTitle}>Admin. clientes</p>
				</div>
			)}
		</div>
	);
};

export default Logo;
